app.service('surveyService', [
  'portalHelper', 'HttpAuth', 'apiHelper', '$location', 'CONSTANTS', '$timeout',
  function (portalHelper, HttpAuth, apiHelper, $location, CONSTANTS, $timeout) {
    const surveyService = this;

    /**
     * By default this function will redirect the user to Survey Deleted page,
     * If you want to override this behavior, you need to pass a success URL.
     * In case a successURL is passed, survey deleted message will be displayed in toastr
     * and user will be redirected to the given successURL.
     * @param {*} survey_id ID of the survey to be deleted.
     * @param {*} successURL URL on which user should be redirected after deleting the survey.
     */
    surveyService.deleteSurvey = function (survey_id) {
      portalHelper.showPopupYesNo('Delete Survey?',
        'Are you sure you want to delete this Survey?',
        function () {
          const url = apiHelper.getApiUrl() + '/api/authoring/survey/' + survey_id + '.json';
          HttpAuth.delete(url).then(
            function (result) {
              $location.path('Admin/SurveyDeleted');
            },
            function (result) {
              portalHelper.showErrorCommon(result);
            }
          );
        });
    };
  }
]);